import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  pageRoot: {
    overflowX: 'hidden',
  },
  formSection: {
    marginTop: '20px',
  },
  // Centraliza verticalmente com o input ao lado (centro do input = 25.625px
  // a partir do topo da coluna Grid24: 15px de label + metade dos 21.25px do input).
  // marginTop = 25.625 - (altura do botão / 2).
  searchButtonCircular: {
    marginTop: '3.625px', // botão circular de 44px
  },
});
